import React, { useState } from "react";

const UploadItem = () => {
  const [files, setFiles] = useState([]);
  const [items, setItems] = useState([]); // 🔥 NEW
  const [folderID, setFolderID] = useState("");
  const [type, setType] = useState("");
  const [text, setText] = useState("");
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [textPosition, setTextPosition] = useState("left");

  const getImageOrder = (url) => {
  const name = url.split("/").pop(); // get filename

  const match = name.match(/\((\d+)\)/); // (1), (2), etc

  if (!match) return 0; // no number = first image

  return parseInt(match[1], 10);
};

 const isMultiWithText =
  type === "multiple_images_title_subtitle" ||
  type === "multiple_icons_title_subtitle" ||
  type === "multiple_image_top_text_position" ||
  type === "multiple_images_title_subtitle_horizantal_scroll";

  const hasTitleSubtitle =
    type === "image_right_with_title_subtitle" ||
    type === "title_image_subtitle" ||
     type === "image_top_text_position" ||
    type === "text_only";

  const needsFile = type !== "text_only";

  const allowsMultipleFiles =
    type === "slide_images" || isMultiWithText;

  // =========================
  // FILE HANDLER
  // =========================
  const handleFileChange = (e) => {
    const selectedFiles = [...e.target.files];
    if (selectedFiles.length === 0) return;

    if (isMultiWithText) {
      const mapped = selectedFiles.map((file) => ({
        file,
        title: "",
        subtitle: "",
        textPosition: "left",
      }));
      setItems(mapped);
    } else if (allowsMultipleFiles) {
      setFiles(selectedFiles);
    } else {
      setFiles([selectedFiles[0]]);
    }
  };

  // =========================
  // UPDATE PER IMAGE TEXT
  // =========================
  const updateItem = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    setItems(updated);
  };

  const resetForm = () => {
    setFiles([]);
    setItems([]);
    setText("");
    setTitle("");
    setSubtitle("");
    setTextPosition("left");
  };

  // =========================
  // SUBMIT
  // =========================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!folderID || !type) {
      alert("Please fill folder ID and select type.");
      return;
    }

    if (needsFile && !isMultiWithText && files.length === 0) {
      alert("Please select at least one file.");
      return;
    }

    if (isMultiWithText && items.length === 0) {
      alert("Please upload images.");
      return;
    }

    if (hasTitleSubtitle && !title.trim() && !subtitle.trim()) {
      alert("Please enter title, subtitle, or both.");
      return;
    }

    const formData = new FormData();
    formData.append("folderID", folderID);
    formData.append("type", type);

    // 🔥 MULTI IMAGE WITH PER TEXT
    if (isMultiWithText) {
      items.forEach((item, i) => {
        formData.append("files", item.file);
        formData.append(`titles[${i}]`, item.title);
        formData.append(`subtitles[${i}]`, item.subtitle);
        formData.append(`textPositions[${i}]`, item.textPosition || "left");
      });
    }

    // NORMAL TITLE/SUBTITLE TYPES
    else if (hasTitleSubtitle) {
      formData.append("title", title.trim());
      formData.append("subtitle", subtitle.trim());
      formData.append("textPosition", textPosition);
      formData.append(
        "text",
        [title.trim(), subtitle.trim()].filter(Boolean).join("\n")
      );
    }

    // SIMPLE TEXT
    else {
      formData.append("text", text.trim());
    }

    // NORMAL FILE TYPES
    if (!isMultiWithText && needsFile) {
      files.forEach((file) => formData.append("files", file));
    }

    try {
      const response = await fetch("https://api.malidag.com/api/items/upload", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        alert("Item uploaded successfully!");
        resetForm();
      } else {
        alert("Upload failed: " + data.error);
      }
    } catch (error) {
      console.error("Error uploading item:", error);
      alert("Upload failed.");
    }
  };

  // =========================
  // UI
  // =========================
  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Upload Item</h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          placeholder="Folder ID"
          value={folderID}
          onChange={(e) => setFolderID(e.target.value)}
          className="border p-2 w-full"
        />

        <select
          value={type}
          onChange={(e) => {
            setType(e.target.value);
            resetForm();
          }}
          className="border p-2 w-full"
        >
          <option value="">Select Type</option>

          <option value="slide_images">Slide Images</option>
          <option value="image_with_text">Image with Text</option>
          <option value="single_image">Single Image</option>
          <option value="image-Left_with_text">Left Image with Text</option>
          <option value="video_with_text">Video with Text</option>
          <option value="single_video">Single Video</option>
          <option value="image_top_text_position">
            Image with Text Above - Left / Center / Right
          </option>
          <option value="multiple_image_top_text_position">
            Multiple Images with Text Above - Horizontal Scroll
          </option>

          <option value="image_right_with_title_subtitle">
            Image Right + Title + Subtitle
          </option>

          <option value="title_image_subtitle">
            Title + Image + Subtitle
          </option>

          <option value="multiple_images_title_subtitle">
            Multiple Images (Each with Title + Subtitle)
          </option>

          <option value="multiple_icons_title_subtitle">
            Multiple Icons (Each with Title + Subtitle)
          </option>

          <option value="multiple_images_title_subtitle_horizantal_scroll">
          Multiple Images (Horizontal Scroll + Title + Subtitle)
        </option>

          <option value="text_only">Text Only</option>
        </select>

        {/* PER IMAGE TITLE/SUBTITLE */}
        {isMultiWithText && (
          <div className="space-y-6">
            {items.map((item, index) => (
              <div key={index} className="border p-3">
                <p className="font-bold mb-2">Image {index + 1}</p>

                <input
                  type="text"
                  placeholder="Title"
                  value={item.title}
                  onChange={(e) =>
                    updateItem(index, "title", e.target.value)
                  }
                  className="border p-2 w-full mb-2"
                />

                <textarea
                  placeholder="Subtitle"
                  value={item.subtitle}
                  onChange={(e) =>
                    updateItem(index, "subtitle", e.target.value)
                  }
                  className="border p-2 w-full"
                />

                {type === "multiple_image_top_text_position" && (
                  <select
                    value={item.textPosition}
                    onChange={(e) =>
                      updateItem(index, "textPosition", e.target.value)
                    }
                    className="border p-2 w-full mt-2"
                  >
                    <option value="left">Left text</option>
                    <option value="center">Middle text</option>
                    <option value="right">Right text</option>
                  </select>
                )}
              </div>
            ))}
          </div>
        )}

        {/* NORMAL TITLE/SUBTITLE */}
        {!isMultiWithText && hasTitleSubtitle && (
          <>
            <input
              type="text"
              placeholder="Title optional"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="border p-2 w-full"
            />

            <textarea
              placeholder="Subtitle optional"
              value={subtitle}
              onChange={(e) => setSubtitle(e.target.value)}
              className="border p-2 w-full"
            />

            {type === "image_top_text_position" && (
            <select
              value={textPosition}
              onChange={(e) => setTextPosition(e.target.value)}
              className="border p-2 w-full"
            >
              <option value="left">Left text</option>
              <option value="center">Middle text</option>
              <option value="right">Right text</option>
            </select>
          )}
          </>
        )}

        {/* TEXT */}
        {!isMultiWithText && !hasTitleSubtitle && (
          <textarea
            placeholder="Text optional"
            value={text}
            onChange={(e) => setText(e.target.value)}
            className="border p-2 w-full"
          />
        )}

        {/* FILE INPUT */}
        {needsFile && (
          <input
            type="file"
            multiple={allowsMultipleFiles}
            accept={type.includes("video") ? "video/*" : "image/*"}
            onChange={handleFileChange}
            className="border p-2 w-full"
          />
        )}

        <button className="bg-blue-500 text-white p-2 rounded">
          Upload Item
        </button>
      </form>
    </div>
  );
};

export default UploadItem;